import { render } from "./DarkModeToggle.vue?vue&type=template&id=687fc7e6"
import script from "./DarkModeToggle.vue?vue&type=script&lang=ts"
export * from "./DarkModeToggle.vue?vue&type=script&lang=ts"
script.render = render

export default script